import { useContext } from 'react'

import AppContext from "../context/AppContext"

const UserAppContext = () => {

      const context = useContext(AppContext)

      if(context === undefined){
            throw new Error('Not exists in context')
      }

      return context
}

export default UserAppContext